import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import {
    CreateOrderPopCheckoutEmailsInput,
    ModelOrderPopCheckoutEmailsFilterInput,
    ModelSortDirection,
    OrderPopCheckoutEmails,
    UpdateOrderPopCheckoutEmailsInput
} from '@app/core/services/api/API.service';
import * as mutations from '@graphql/mutations';
@Injectable({
    providedIn: 'root'
})
export class OrderPopCheckoutEmailsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listAllByCompanyId(
        companyId: string,
        filter: ModelOrderPopCheckoutEmailsFilterInput = null,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        limit: number = 20
    ): Promise<OrderPopCheckoutEmails[]> {
        const emails: OrderPopCheckoutEmails[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.OrderPopCheckoutEmailsByCompanyId,
                        variables: {
                            companyId,
                            nextToken,
                            filter,
                            limit,
                            sortDirection
                        }
                    })
                ).data.OrderPopCheckoutEmailsByCompanyId;
                emails.push(
                    ...((response?.items ?? []) as OrderPopCheckoutEmails[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return emails;
        } catch (error) {
            console.error('Error finding OrderPopCheckoutEmails:', error);
            return [];
        }
    }

    async listOrderPopCheckoutEmails(): Promise<OrderPopCheckoutEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderPopCheckoutEmails
                })
            ).data.listOrderPopCheckoutEmails.items;
            if (data) return data as OrderPopCheckoutEmails[];
        } catch (error) {
            console.error('Error finding OrderPopCheckoutEmails:', error);
            return null;
        }
    }

    async orderPopCheckoutEmailsByCompanyId(
        companyId: string
    ): Promise<OrderPopCheckoutEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderPopCheckoutEmailsByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.OrderPopCheckoutEmailsByCompanyId.items;
            if (data) return data as OrderPopCheckoutEmails[];
        } catch (error) {
            console.error('Error finding OrderPopCheckoutEmails:', error);
            return null;
        }
    }

    async createOrderPopCheckoutEmails(
        input: CreateOrderPopCheckoutEmailsInput
    ): Promise<OrderPopCheckoutEmails> {
        try {
            const qaEmails = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderPopCheckoutEmails,
                    variables: {
                        input
                    }
                })
            ).data.createOrderPopCheckoutEmails;
            if (qaEmails) return qaEmails as OrderPopCheckoutEmails;
        } catch (error) {
            console.error('Error creating OrderPopCheckoutEmails:', error);
            return null;
        }
    }

    async updateQAEmails(
        input: UpdateOrderPopCheckoutEmailsInput
    ): Promise<OrderPopCheckoutEmails> {
        try {
            const qaEmails = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderPopCheckoutEmails,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderPopCheckoutEmails;
            if (qaEmails) return qaEmails as OrderPopCheckoutEmails;
        } catch (error) {
            console.error('Error updated OrderPopCheckoutEmails', error);
            return null;
        }
    }
}
